module.exports = __webpack_public_path__ + "assets/img/1511587607715_.pic_hd.71129ead.jpg";